import { IAppState } from '../rootDuck';

export const selectCountryId = (state: IAppState) => state.auth.countryId;
